.s{flex-direction:row;}